/**
 * Empty state component for displaying when lists are empty
 */

import { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  testId?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  testId,
}: EmptyStateProps) {
  return (
    <div
      className={cn("text-center py-4 text-muted-foreground", className)}
      data-testid={testId}
    >
      {description ? (
        <>
          <p className="text-sm">{description}</p>
          {action && (
            <Button
              onClick={action.onClick}
              className="mt-2"
              size="sm"
              data-testid={`${testId}-action`}
            >
              {action.label}
            </Button>
          )}
        </>
      ) : (
        <>
          <Icon className="h-16 w-16 mx-auto mb-4 opacity-20" />
          <p className="text-base">{title}</p>
          {action && (
            <Button
              onClick={action.onClick}
              className="mt-4"
              data-testid={`${testId}-action`}
            >
              {action.label}
            </Button>
          )}
        </>
      )}
    </div>
  );
}

